import {
    put, call, all, takeLatest, select
} from 'redux-saga/effects';
import { defaultSaga, getActions } from '../utils';

import * as constants from './constants';
import * as actions from './actions';
import * as api from './api';
import converter from './converter';

export default function* rootSaga() {
    yield all([
        yield takeLatest(
            constants.getCalculatorsSoilDepth.toString(),
            defaultSaga({
                constants: constants.getCalculatorsSoilDepth,
                api: api.getCalculatorsSoilDepth
            })
        ),
        yield takeLatest(
            constants.getCalculatorsSoilDepthItem.toString(),
            defaultSaga({
                constants: constants.getCalculatorsSoilDepthItem,
                api: api.getCalculatorsSoilDepthItem
            })
        )
    ]);
}